import { render } from "./wEmail.vue?vue&type=template&id=38922489&ts=true"
import script from "./wEmail.vue?vue&type=script&lang=ts"
export * from "./wEmail.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__